<template>
  <div class="areaCity">
    <area-cascader :level="0" type="text" v-model="city" :data="pca"></area-cascader>
  </div>
</template>

<script>
import { pca, pcaa } from 'area-data'; // 城市数据
import 'vue-area-linkage/dist/index.css'; // 样式
export default {
  props: {
    address: String,
    cityIndex: String
  },
  data() {
    return {
      city: this.address ? JSON.parse(this.address) : [],
      pca: pca,
      pcaa: pcaa
    }
  },
  updated() {
    this.$emit('city', this.city)
  }
}
</script>

<style lang="less" type="text/less">
  .area-cascader-wrap{
    .area-select{
      height: 32px;
      border:1px solid #e1e2e6 !important;
      &.large{
        width: 100%;
        height: 100%;
      }
      .area-selected-trigger{
        line-height: 24px;
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AreaCity.vue